import { render, staticRenderFns } from "./Canal.vue?vue&type=template&id=6bbb32f0"
import script from "./Canal.vue?vue&type=script&lang=js"
export * from "./Canal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports